import { BookOpen } from 'lucide-react'
import { defineModule } from '@/shell/module-system'
import { SopLibraryPage } from './pages/SopLibraryPage'
import { SopLibraryReaderPage } from './pages/SopLibraryReaderPage'

/**
 * SOP Library — read-only reference library of Standard Operating
 * Procedures for every internal role (not the external `uviva` vendor
 * role). Search + filter + download + email-a-colleague. No authoring
 * affordances here — that lives on the separate `/sop-manage` admin
 * surface (sop-management module), same split as CofA's
 * cofa-documents/cofa-pipeline pair.
 */
export default defineModule({
  id: 'sop-library',
  name: 'SOP Library',
  shortName: 'SOPs',
  icon: BookOpen,
  navSection: 'home',
  navOrder: 20,
  urlNamespace: '/sop-library',
  routes: [
    { path: '/', element: SopLibraryPage, label: 'SOP Library' },
    { path: '/$sopId', element: SopLibraryReaderPage, label: 'SOP' },
  ],
  permissions: [
    'admin', 'sales', 'outside_sales_rep', 'inside_sales_rep',
    'operations', 'operations_logistics', 'regulatory', 'finance',
    'purchasing', 'warehouse', 'viewer',
  ],
  densityDefault: 'comfortable',
  mobileStrategy: 'desktop-only',
  keyboardShortcut: 'g s l',
  commandPaletteEntries: [
    {
      label: 'Go to SOP Library',
      keywords: ['sop', 'procedure', 'library', 'reference', 'how to', 'documentation'],
      path: '/',
      group: 'modules',
      shortcut: 'g s l',
    },
  ],
})
